import { Col, Row, Form as BSForm } from 'react-bootstrap';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { MasterDataService } from '../../../../../services/masterDataService';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';

export const LanguageProficiencyForm = ({ handleChange, values, errors, touched }) => {
  let [languages, setLanguages] = useState([]);
  useEffect(() => {
    MasterDataService.getAllLanguages().then((data) => {
      setLanguages(data.data);
    });
  }, []);
  return (
    <FieldArray name="languageProficiency">
      {({ remove, push }) => (
        <>
          {values.languageProficiency &&
            values.languageProficiency.length > 0 &&
            values.languageProficiency.map((languageProficiency, index) => (
              <Row className="mb-2" key={index}>
                <BSForm.Group as={Col} controlId={`languageProficiency.${index}.language`}>
                  <BSForm.Label>Language*</BSForm.Label>
                  <BSForm.Select
                    name={`languageProficiency.${index}.language`}
                    onChange={handleChange}
                    className={`form-control ${getErrorClass(
                      errors,
                      touched,
                      `languageProficiency.${index}.language`
                    )}`}
                    value={languageProficiency.language}
                  >
                    <option value="">--Select--</option>
                    {languages.map((language) => (
                      <option value={language}> {language}</option>
                    ))}
                  </BSForm.Select>
                  <span className="errorMessage">
                    {getErrorMessage(errors, touched, `languageProficiency.${index}.language`, true)}
                  </span>
                </BSForm.Group>
                <BSForm.Group as={Col} controlId={`languageProficiency.${index}.proficiency`}>
                  <BSForm.Label>Proficiency</BSForm.Label>
                  <BSForm.Select
                    name={`languageProficiency.${index}.proficiency`}
                    onChange={handleChange}
                    value={languageProficiency.proficiency}
                    className={`form-control ${getErrorClass(
                      errors,
                      touched,
                      `languageProficiency.${index}.proficiency`
                    )}`}
                  >
                    <option value="">--Select--</option>
                    <option value="READING_PROFICIENCY">Reading Proficiency</option>
                    <option value="WRITING_PROFICIENCY">Writing Proficiency</option>
                    <option value="SPEAKING_PROFICIENCY">Speaking Proficiency</option>
                    <option value="FULL_PROFICIENCY">Full Proficiency</option>
                  </BSForm.Select>
                  <span className="errorMessage">
                    {getErrorMessage(errors, touched, `languageProficiency.${index}.proficiency`, true)}
                  </span>
                </BSForm.Group>
                <BSForm.Group
                  as={Col}
                  controlId="removeCol"
                  className="d-flex justify-content-center align-items-center"
                >
                  <LinkButton onClick={() => remove(index)} icon={faMinusCircle}></LinkButton>
                </BSForm.Group>
              </Row>
            ))}

          <Row className="mb-3">
            <Col>
              <LinkButton
                label="Add Language"
                onClick={() =>
                  push({
                    language: '',
                    proficiency: null,
                  })
                }
              ></LinkButton>
            </Col>
          </Row>
        </>
      )}
    </FieldArray>
  );
};
